import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Gantt } from '@app/core/components/gantt/gantt.model';
import { GanttOptions } from '@app/core/components/gantt/gantt.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CapTaskService, CapTasksViewGet, GetCapTasksViewParams } from '@app/services/cap-task.service';

@Component({
    selector: 'tt-cap-tasks-view',
    templateUrl: './cap-tasks-view.component.html',
    styleUrls: ['./cap-tasks-view.component.css'],
})
export class CapTasksViewComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetCapTasksViewParams;

    public page?: CapTasksViewGet;

    public gantt: GanttOptions = new Gantt().setLoadDataFunction({ method: 4066, parameters: () => this.page });

    constructor(
        private capTask: CapTaskService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadPage() {
        if (!!this.params) {
            this.page = await this.capTask.getCapTasksView(this.params);
        }
    }

    private async init() {
        await this.loadPage();
        this.navigator?.setHeading?.(this.page?.page_heading ?? '');
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }
}
